export const absolute = (value) => {
	return typeof value === 'number' ? Math.abs(parseFloat(value)) : value;
};
